// استيراد دوال React لإدارة الحالات والتأثيرات الجانبية
import { useEffect, useState } from "react";
// استيراد روابط API الخاصة بالتصنيفات
import { Cat, CATEGORIES } from "../../../API/Api";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد Link للتنقل بين الصفحات
import { Link } from "react-router-dom";
// استيراد أيقونة الإضافة من Font Awesome
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون عرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد مكون عرض الجدول
import TableShow from "../../../components/Dashboard/Table";
// استيراد سياق اللغة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف الأنماط
import "../../../components/Dashboard/FormPage.css";

// المكون الرئيسي لإدارة التصنيفات
export default function Categories ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // حالة لتخزين قائمة التصنيفات
    const [ categories, setCategories ] = useState( [] );
    // حالة لتحديد عدد العناصر في الصفحة الواحدة
    const [ limit, setLimit ] = useState( 5 );
    // حالة لتحديد رقم الصفحة الحالية
    const [ page, setPage ] = useState( 1 );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // حالة لتخزين العدد الإجمالي للتصنيفات
    const [ total, setTotal ] = useState( 0 );

    // تأثير جانبي لجلب بيانات التصنيفات عند تغيير الصفحة أو الحد
    useEffect( () =>
    {
        // تفعيل حالة التحميل
        setLoading( true );
        // إرسال طلب GET لجلب التصنيفات مع معلمات الترقيم
        Axios.get( `/${ CATEGORIES }?limit=${ limit }&page=${ page }` )
            .then( ( res ) =>
            {
                // تخزين بيانات التصنيفات
                setCategories( res.data.data );
                // تخزين العدد الإجمالي
                setTotal( res.data.total );
            } )
            .catch( ( error ) => console.log( "Error fetching categories:", error ) ) // معالجة الأخطاء
            .finally( () => setLoading( false ) ); // إلغاء حالة التحميل في النهاية
    }, [ limit, page ] ); // إعادة التشغيل عند تغيير الحد أو الصفحة

    // تعريف أعمدة الجدول مع الترجمة
    const header = [
        { key: "title", name: t( 'categories.columnTitle' ) }, // عمود العنوان
        { key: "image", name: t( 'categories.columnImage' ) }, // عمود الصورة
        { key: "created_at", name: t( 'categories.columnCreated' ) }, // عمود تاريخ الإنشاء
        { key: "updated_at", name: t( 'categories.columnUpdated' ) }, // عمود تاريخ التحديث
    ];

    // دالة غير متزامنة لحذف تصنيف
    const handleDelete = async ( id ) =>
    {
        try
        {
            // إرسال طلب DELETE لحذف التصنيف
            await Axios.delete( `/${ Cat }/${ id }` );
            // تحديث قائمة التصنيفات بحذف التصنيف المحدد
            setCategories( ( prev ) => prev.filter( ( item ) => item.id !== id ) );
        } catch ( error )
        {
            // طباعة خطأ الحذف في وحدة التحكم
            console.log( "Error deleting category:", error );
        }
    };

    // عرض واجهة إدارة التصنيفات
    return (
        <div className="list-page-card"> {/* بطاقة صفحة القائمة */ }
            <div className="list-page-header"> {/* رأس الصفحة */ }
                <h2 className="list-page-title">{ t( 'categories.pageTitle' ) }</h2> {/* عنوان الصفحة المترجم */ }
                {/* زر إضافة تصنيف جديد */ }
                <Link className="list-page-add-btn" to="/dashboard/category/add">
                    <FontAwesomeIcon icon={ faPlus } /> {/* أيقونة الإضافة */ }
                    <span>{ t( 'categories.addButton' ) }</span> {/* نص الزر المترجم */ }
                </Link>
            </div>

            {/* مكون عرض الجدول مع تمرير الخصائص */ }
            <TableShow
                limit={ limit } // عدد العناصر في الصفحة
                page={ page } // الصفحة الحالية
                header={ header } // أعمدة الجدول
                data={ categories } // بيانات التصنيفات
                delete={ handleDelete } // دالة الحذف
                setpage={ setPage } // دالة تغيير الصفحة
                setLimit={ setLimit } // دالة تغيير الحد
                loading={ loading } // حالة التحميل
                total={ total } // العدد الإجمالي
                search="title" // حقل البحث
                searchLinck={ Cat } // رابط البحث
            />

            {/* تذييل الصفحة */ }
            <footer className="list-page-footer">
                <p className="m-0">{ t( 'footer.rights' ) }</p> {/* نص حقوق الملكية المترجم */ }
            </footer>
        </div>
    );
}